module.exports = __webpack_public_path__ + "img/f30f79bbcaff0473c5e1a525yya01648.00ff96f4.png";